import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {UnreachableError} from '../../../../../libs/shared/core/src/helpers/types/customErrors';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {
  AiTaggingErrorBannerState,
  AiTaggingErrorBannerTypesEnum,
} from '../../../../store/panels/app/banners/bannersState';

/*
 * Props.
 */

interface AiTaggingErrorBannerProps {
  state: AiTaggingErrorBannerState;
  onDismissClick: () => void;
}

/*
 * Component.
 */

export const AiTaggingErrorBanner: FC<AiTaggingErrorBannerProps> = (props) => {
  const theme = useUserTheme();
  const {state, onDismissClick} = props;

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.red.shade40}
      priority={BannerPrioritiesEnum.ERROR}
    >
      <BannerCloseAction onClick={onDismissClick} />
      <BannerContent>
        <BannerContentTitle>{getBannerContentTitle(state)}</BannerContentTitle>
        <Trans id="ai-tagging-error-banner-please-try-again-message">Please try again.</Trans>
      </BannerContent>
    </Banner>
  );
};

/*
 * Helpers.
 */

function getBannerContentTitle(state: AiTaggingErrorBannerState) {
  const {aiTaggingErrorType} = state;
  switch (aiTaggingErrorType) {
    case AiTaggingErrorBannerTypesEnum.MANUAL_FEEDBACK_FAILED:
      return (
        <Trans id="ai-tagging-error-banner-manual-feedback-failed">Failed to report inaccurate tag</Trans>
      );
    default:
      throw new UnreachableError(aiTaggingErrorType);
  }
}
